import { useEffect, useRef } from 'react';
import { useRealtimeKitClient } from '@cloudflare/realtimekit-react';
import { api } from '@/lib/api';

/**
 * Initializes the Cloudflare Realtime (RTK/Dyte) connection in the background.
 * Children always render immediately — RTK is a non-critical enhancement.
 * Twilio browser SDK handles calls as the primary transport.
 */
export function RealtimeWrapper({ children }: { children: React.ReactNode }) {
  const [, connect] = useRealtimeKitClient();
  const initiated = useRef(false);

  useEffect(() => {
    if (initiated.current) return;
    initiated.current = true;

    async function initRealtime() {
      try {
        const { token } = await api.getRealtimeToken();
        console.log('[RTK] Token minted, connecting to meeting...');
        await connect({ authToken: token });
        console.log('[RTK] Meeting joined successfully');
      } catch (err) {
        // RTK is non-critical — Twilio handles calls as fallback
        console.warn('[RTK] Connection failed (Twilio active as fallback):', err);
      }
    }

    initRealtime();
  }, [connect]);

  // Always render children — RTK state managed internally by useRealtimeKitClient
  return <>{children}</>;
}
